import { fileTypes } from '../../constants/file-types'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function downloadReport(fileName, setDownloadStatus, fileType) {
  const apiPath = `v1/download?filename=${fileName}&fileType=${fileType}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  try {
    const response = await httpClient.shippingInstance().get(apiPath, { responseType: 'blob' })
    if (response.status === 200 && response?.data) {
      const blob = new Blob([response.data], { type: fileTypes.download.PDF })
      if (blob.size === 0) {
        setDownloadStatus('Empty File')
      } else {
        /* Create File Url */
        const fileUrl = window.URL.createObjectURL(blob)
        /* Open File in New Browser Tab */
        window.open(fileUrl, '_blank')
      }
    }
  } catch {
    // Nothing to do here
  }
}
